import { render, staticRenderFns } from "./HoldingsBarChart.vue?vue&type=template&id=83c31c10"
import script from "./HoldingsBarChart.vue?vue&type=script&lang=js"
export * from "./HoldingsBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports